module.exports = __webpack_public_path__ + "img/Size=20, Style=regular.ce316959.svg";